import { TextInput as RootTextInput } from "react-native";

export const TextInput = RootTextInput;
